import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { ReserveOnlineInsureAgreementFormFragmentComponent } from './ReserveOnlineInsureAgreementFormFragmentComponent';
import {ExamAfterProcessService} from '../../../../../../Service/ExamAfterProcessService';

export class ReserveOnlineInsureAgreementFormFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: ReserveOnlineInsureAgreementFormFragmentComponent;

}
